<div class="datepicker-wrapper">
  <kendo-calendar [min]="minDate" [max]="maxDate" [(value)]="value" [navigation]="true"></kendo-calendar>  
</div>